module.exports = __webpack_public_path__ + "static/media/arrow-talk.ae813594.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-talk.svg
// module id = 235
// module chunks = 0